document.addEventListener('DOMContentLoaded', function () {
    const player = document.getElementById('mp3-player');
    const playPauseButton = document.getElementById('player-play-pause');
    const closeButton = document.getElementById('player-close-button');
    const trackNameElement = document.getElementById('player-track-name');
    const trackArtistElement = document.getElementById('player-track-artist');
    const artworkElement = document.getElementById('player-artwork');
    const externalLinkElement = document.getElementById('player-external-link');
    const progressBar = document.getElementById('player-progress-bar');
    const progressContainer = document.querySelector('.player-progress');
    const volumeControl = document.getElementById('volume-control');

    let audio = new Audio();
    let isPlaying = false;

    // Function to show the player
    function showPlayer() {
        player.classList.remove('hidden');
        player.classList.add('visible');
    }

    // Function to hide the player
    function hidePlayer() {
        player.classList.remove('visible');
        player.classList.add('hidden');
    }

    // Listen for the trackSelected event
    document.addEventListener('trackSelected', (e) => {
        const { mp3Url, trackName, trackArtist, artworkUrl, externalUrl } = e.detail;

        // Update player UI with track details
        trackNameElement.textContent = trackName;
        trackArtistElement.textContent = trackArtist;
        artworkElement.src = artworkUrl;
        externalLinkElement.href = externalUrl;

        // Load the track into the audio element
        audio.src = mp3Url;
        audio.load();

        // Auto play the track when new track is selected
        playPauseButton.innerHTML = '<i class="fas fa-pause"></i>';
        audio.play();
        isPlaying = true;

        // Show the player
        showPlayer();
    });

    // Play/Pause button functionality
    playPauseButton.addEventListener('click', () => {
        if (isPlaying) {
            audio.pause();
            playPauseButton.innerHTML = '<i class="fas fa-play"></i>';
        } else {
            audio.play();
            playPauseButton.innerHTML = '<i class="fas fa-pause"></i>';
        }
        isPlaying = !isPlaying;
    });

    // Close button functionality
    closeButton.addEventListener('click', () => {
        audio.pause();
        audio.currentTime = 0; // Eject the track
        playPauseButton.innerHTML = '<i class="fas fa-play"></i>';
        isPlaying = false;

        // Hide the player
        hidePlayer();
    });

    // Update progress bar as the track plays
    audio.addEventListener('timeupdate', () => {
        const percentage = (audio.currentTime / audio.duration) * 100;
        progressBar.style.width = percentage + '%';
    });

    // Seek functionality by clicking on the progress bar
    progressContainer.addEventListener('click', (e) => {
        const clickX = e.offsetX;
        const width = progressContainer.clientWidth;
        const duration = audio.duration;
        const newTime = (clickX / width) * duration;

        audio.currentTime = newTime;
    });

    // Volume control functionality
    volumeControl.addEventListener('input', () => {
        audio.volume = volumeControl.value;
    });
});
